import { render, staticRenderFns } from "./charactersTrash.vue?vue&type=template&id=b5b66f32&scoped=true&"
import script from "./charactersTrash.vue?vue&type=script&lang=js&"
export * from "./charactersTrash.vue?vue&type=script&lang=js&"
import style0 from "./charactersTrash.vue?vue&type=style&index=0&id=b5b66f32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b66f32",
  null
  
)

export default component.exports